import { Paper, Box, Typography } from '@mui/material';

interface Props {
  icon: React.ReactNode;
  label: string;
  value: string;
  sub?: string;
  accentColor: string;
}

/**
 * 📈 유입경로 통계 전용 프리미엄 KPI 카드
 * - 그라디언트 아이콘 스퀘어클 + 상단 액센트 헤어라인 + 호버 리프트
 */
const InflowKpiCard = ({ icon, label, value, sub, accentColor }: Props) => (
  <Paper
    elevation={0}
    sx={{
      p: 2.2,
      borderRadius: 3,
      height: '100%',
      border: '1px solid #e8edf4',
      background: '#fff',
      position: 'relative',
      overflow: 'hidden',
      transition: 'all 0.2s ease',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: `0 8px 24px ${accentColor}18`,
        borderColor: `${accentColor}40`,
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        background: `linear-gradient(90deg, ${accentColor}, ${accentColor}00)`,
      },
    }}
  >
    <Box display="flex" alignItems="center" gap={1.2} mb={1.5}>
      <Box
        sx={{
          width: 38,
          height: 38,
          borderRadius: '12px',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          background: `linear-gradient(135deg, ${accentColor}, ${accentColor}bb)`,
          boxShadow: `0 4px 10px ${accentColor}30`,
          '& svg': { fontSize: 20 },
        }}
      >
        {icon}
      </Box>
      <Typography sx={{ fontSize: '0.78rem', fontWeight: 700, color: '#64748b', lineHeight: 1.3 }}>
        {label}
      </Typography>
    </Box>

    <Typography sx={{
      fontSize: '1.65rem', fontWeight: 800, color: '#0f172a',
      letterSpacing: '-1px', lineHeight: 1.15,
      whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
    }}>
      {value}
    </Typography>

    {sub && (
      <Typography sx={{ fontSize: '0.7rem', color: '#94a3b8', mt: 0.5, fontWeight: 600 }}>
        {sub}
      </Typography>
    )}
  </Paper>
);

export default InflowKpiCard;
